<template>
  <q-dialog v-model="show">
    <q-card
      v-if="giftCard"
      :style="{ 'width': '500px', 'max-width': '95%' }"
    >
      <q-card-section
        class="text-h5"
      >
        Gift Card Detail
      </q-card-section>

      <q-card-section>
        <div class="row justify-between">
          <div class="col-auto text-bold">
            Purchased At
          </div>
          <div class="col-auto">
            {{ giftCard.createdAt.i18n('mediumLong') }}
          </div>
        </div>
        <div class="row justify-between">
          <div class="col-auto text-bold">
            State
          </div>
          <div class="col-auto">
            {{ $_.startCase(giftCard.state) }}
          </div>
        </div>
        <div class="row justify-between">
          <div class="col-auto text-bold">
            Initial Value
          </div>
          <i18n-n
            class="col-auto"
            tag="span"
            :value="giftCard.initialValue"
            format="currency"
            scope="global"
          />
        </div>
        <div class="row justify-between">
          <div class="col-auto text-bold">
            Current Balance
          </div>
          <i18n-n
            class="col-auto"
            tag="span"
            :value="giftCard.balance"
            format="currency"
            scope="global"
          />
        </div>
        <div
          v-if="giftCard.expiresAt"
          class="row justify-between"
        >
          <div class="col-auto text-bold">
            Expires At
          </div>
          <div class="col-auto">
            {{ giftCard.expiresAt.i18n('mediumLong') }}
          </div>
        </div>
      </q-card-section>

      <q-card-actions class="row justify-between q-ma-sm">
        <q-btn
          v-if="allowViewOrders"
          label="View Orders"
          @click="$refs.ordersByGiftCardDialog.show(null, null, giftCard.id, null)"
        />
        <q-btn
          v-if="giftCard && giftCard.card && giftCard.balance === 0"
          label="Unassociate Card"
          color="negative"
          :loading="deleting"
          @click="deleteCard"
        />
        <q-space />
        <q-btn
          v-close-popup
          label="Done"
        />
      </q-card-actions>
    </q-card>
    <order-filter-by-model-dialog
      ref="ordersByGiftCardDialog"
      @select-order="order => { $emit('select-order', order); show = false }"
    />
  </q-dialog>
</template>

<script>

import OrderFilterByModelDialog from 'src/modules/register/dialogs/OrderFilterByModelDialog.vue'
export default {
  name: 'InspectGiftCardDialog',
  components: { OrderFilterByModelDialog },
  props: {
    modelValue: {
      type: Boolean,
      required: false,
      default: false
    },
    giftCard: {
      type: Object,
      required: false,
      default: null
    },
    allowViewOrders: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ['select-order', 'update:model-value'],
  data () {
    return {
      show: false,
      deleting: false
    }
  },
  watch: {
    modelValue () {
      this.show = this.modelValue
    },
    show () {
      this.$emit('update:model-value', this.show)
    }
  },
  methods: {
    async deleteCard () {
      this.deleting = true
      await this.giftCard.card.delete()
      this.deleting = false
      this.show = false
    }
  }
}

</script>
